import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MuiButton } from '@/components/button/MuiButton';
import React from 'react';

export function MuiDialog({
  id,
  handleClose,
  open,
  dialogTitle,
  dialogContent,
  dialogContentCallbackRef,
  dialogAction,
  sx,
}: {
  id?: string;
  handleClose: () => void;
  open: boolean;
  dialogTitle: string;
  dialogContent: React.ReactNode;
  dialogAction?: React.ReactNode;
  dialogContentCallbackRef?: (node: HTMLElement) => void;
  sx?: DialogProps['sx'];
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby={id}
      open={open}
      maxWidth="md"
      fullWidth
      sx={{
        '.MuiDialog-paper': {
          m: 1,
          width: '100%',
          borderRadius: 2,
        },
        ...sx,
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          pt: 3,
          pb: 1.25,
          px: isMobile ? 3 : 5,
          maxWidth: `calc(100% - 80px)`,
        }}
        id={id}
      >
        <Typography variant="JP/Heading/m/Bold/Tight">{dialogTitle}</Typography>
      </DialogTitle>
      <MuiButton
        aria-label="close"
        onClick={handleClose}
        variant="text"
        color="inherit"
        sx={{
          position: 'absolute',
          right: isMobile ? 24 : 40,
          top: 20,
        }}
      >
        <Typography variant="JP/Body/s/Medium/None">とじる</Typography>
        <CloseIcon sx={{ fontSize: '20px', ml: 0.5 }} />
      </MuiButton>
      <DialogContent
        sx={{ py: 3, px: isMobile ? 3 : 5 }}
        ref={dialogContentCallbackRef}
      >
        {dialogContent}
      </DialogContent>
      {!!dialogAction && (
        <DialogActions
          sx={{
            justifyContent: 'center',
            p: 1.5,
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          {dialogAction}
        </DialogActions>
      )}
    </Dialog>
  );
}
